import { keys } from './keys';

export const en = {
  [keys.productList.product.title]: 'Products',
  [keys.productList.service.title]: 'Services',
  [keys.productList.operations.title]: 'Operations',
};
